module.exports = __webpack_public_path__ + "img/lx.7123aeaf.png";